import enData from './en.json'
import fiData from './translations/fi.json'

export const localeData = {
  en: { ...enData },
  fi: { ...enData, ...fiData }
}
